import { SALESFORCE_CANCELLATION_POLICY_LABELS } from '~/utils/mapSFCancelltionPolicyToAdmin';

import { type BuildDetailsFieldsParams, checkboxField, selectField, typedField, withLayout } from '../fieldHelpers';
import type { DetailField } from '../types';

export function buildFunctionalDetailsFields({ opportunity }: BuildDetailsFieldsParams): Array<DetailField> {
  const functionalDetails = opportunity?.functional_details;

  return [
    withLayout(
      selectField(
        'Cancellation Policy',
        functionalDetails?.cancellation_policy__c,
        SALESFORCE_CANCELLATION_POLICY_LABELS,
        undefined,
        { columns: 4 },
      ),
      { columns: 4, span: 'full' },
    ),
    typedField(
      'Date Change Allowed (Disallowed)',
      functionalDetails?.days_before_check_in_changes_disallowed__c,
      'number',
      'Customer can change their dates or convert to BNBL up until this number of days before their check in date.',
      { columns: 4 },
    ),
    typedField(
      'Date Change Allowed',
      undefined,
      'number',
      'This should only be populated if the date changes allowed are unlimited.',
      { columns: 4 },
    ),
    typedField('Number of Date Changes', functionalDetails?.number_of_date_changes__c, 'number', undefined, {
      columns: 4,
    }),
    typedField('Booking Data Cut-off (Days)', undefined, 'number', undefined, { columns: 4 }),
    checkboxField('Package Upgrades Allowed', functionalDetails?.package_upgrades_allowed__c, undefined, {
      columns: 4,
      inline: true,
    }),
    checkboxField('No SEM support for this deal', undefined, undefined, { columns: 4, inline: true }),
    checkboxField('Display Value', true, 'Display value indicator', { columns: 4, inline: true }),
    checkboxField('Surcharges Approved By Legal', undefined, undefined, { columns: 4, inline: true }),
  ];
}
